


































import { Component, Vue } from 'vue-property-decorator';
import { LoginRecord } from '@/interfaces/LoginRecord';
import { fullDateTime } from '@/helpers/dateFormatter';

@Component({
    name: 'AccountLogs',
})
export default class AccountLogs extends Vue {
    protected get loginRecords() {
        return this.$store.getters['user/loginRecords'];
    }

    protected sortMethod(a: LoginRecord, b: LoginRecord) {
        const firstDate = +new Date(a.createdAt);
        const secondDate = +new Date(b.createdAt);
        return firstDate - secondDate;
    }

    protected formattedDate(dateTimestamp: string) {
        return fullDateTime(dateTimestamp);
    }
}
